import { render, staticRenderFns } from "./Theme4Section2.vue?vue&type=template&id=62f9cb70&scoped=true&"
import script from "./Theme4Section2.vue?vue&type=script&lang=js&"
export * from "./Theme4Section2.vue?vue&type=script&lang=js&"
import style0 from "./Theme4Section2.vue?vue&type=style&index=0&id=62f9cb70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f9cb70",
  null
  
)

export default component.exports